import { render, staticRenderFns } from "./ScholarshipJudgeAssignment.vue?vue&type=template&id=622ad13a"
import script from "./ScholarshipJudgeAssignment.vue?vue&type=script&lang=js"
export * from "./ScholarshipJudgeAssignment.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipJudgeAssignment.vue?vue&type=style&index=0&id=622ad13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports